<template>
    <div>
        <div class="form-group">
            <slot name="label">
                <span>{{ label }}</span>
            </slot>
        </div>

        <input
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :type="type"
            :class="['w-100 custom-input-transparent', {'is-invalid': isInvalid}]"
            :autocomplete="autocomplete"
            :maxlength="maxlength"
            :pattern="pattern"
            :oninput="oninput"
            :step="step"
        >
    </div>
</template>

<script>
export default {
    name: 'basic-input',
    props: {
        modelValue: {
            type: [String, Number, null],
            required: true
        },
        label: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'text'
        },
        autocomplete: {
            type: String,
            default: ''
        },
        isInvalid: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: [Number, String],
            default: null
        },
        pattern: {
            type: [Number, String],
            default: null
        },
        oninput: {
            type: [Function, String],
            default: null
        },
        step: [String, null]
    }
}
</script>